// extracted by mini-css-extract-plugin
var _1 = "dot-flashing__NEVoj";
export { _1 as "dotFlashing" }
